module.exports = __webpack_public_path__ + "img/231-libya.d84f64c7.svg";